import Video from './bootstrap-components/components/video/Video';
import Embed from './bootstrap-components/components/video/Embed';
import Image from './bootstrap-components/components/Image';
import Heading from './bootstrap-components/components/Heading';

import Text from './bootstrap-components/components/Text';
import Container from './bootstrap-components/components/Container';
import FlexRow from './bootstrap-components/components/FlexRow';
import Grid from './bootstrap-components/components/Grid';
import FormEditor from './bootstrap-components/components/FormEditor';
import ReferenceDisplayComponent from './bootstrap-components/components/ReferenceDisplay';
import layoutColumns from './BasicBlocks/layout-columns';
import dynamicColumns from './BasicBlocks/dynamic-columns';
import linkBlock from './BasicBlocks/link-block';
import mapBlock from './BasicBlocks/map-block';
import { sioSections } from './sio-sections';
import section from './BasicBlocks/components/section';
import div from './BasicBlocks/components/div';
import breadcrumbs from './BasicBlocks/components/breadcrumbs';
import linkbox from './BasicBlocks/components/linkbox';
import button from './BasicBlocks/components/button';
import iconBlock from './BasicBlocks/components/icon';
import divider from './BasicBlocks/components/divider';
import spacer from './BasicBlocks/components/spacer';
import imageBox from './BasicBlocks/components/imageBox';
import swiperSlider from './BasicBlocks/components/slider/index';
import gallery from './BasicBlocks/components/gallery';
import list from './BasicBlocks/components/list';
import tabs from './BasicBlocks/components/tabs/tabs';
import popover from './BasicBlocks/components/popover/popover';
import addAccordionComponent from './BasicBlocks/components/accordion.js/accortion';
import searchInput from './SearchBlocks/search-input';
import intentBlock from './BasicBlocks/components/intent-block';

import menuBlock from './MenuBlock/menuBlock';
import customCodeBlock from './customCode/customCodeBlock';
// import blogsList from './BasicBlocks/components/blogsList';
import SearchBar from './SearchBlocks/SearchBar';
// import offersList from './BasicBlocks/components/offersList';
// import eventsList from './BasicBlocks/components/eventsList';
import LoginModal from './BasicBlocks/components/modals/LoginModal';
import reactComponent from './bootstrap-components/components/react-component';
import ChoiceDisplay from './bootstrap-components/components/ChoiceDisplay';
import LanguageSwitcher from './BasicBlocks/components/languageSwitcher';
import translationTextBlock from './translation-text/translation-text-block';
import Paragraph from './bootstrap-components/components/Paragraph';
import TimeStamp from './BasicBlocks/components/timeStamp';
import fieldWrapper from './dynamicBlocks/fieldWrapper';
import landingPageImage from './dynamicBlocks/landingPageImage';
import wishlistButton from './TeaserBlocks/wishlistButton/wishlistButton';
import daysCount from './TeaserBlocks/daysCount/daysCount';
import cheapestPrice from './TeaserBlocks/cheapestPrice/cheapestPrice';
import journeyDateSelect from './TeaserBlocks/journeyDateSelect/journeyDateSelect';
import gallerySection from './JourneyDetailBlocks/gallerySection/gallerySection';
import locationSection from './JourneyDetailBlocks/locationSection/locationSection';
import journeyDetailBreadcrumbs from './JourneyDetailBlocks/journeyDetailBreadcrumbs/journeyDetailBreadcrumbs';
import navigationBar from './JourneyDetailBlocks/navigationBar/navigationBar';
import dateAndPriceSection from './JourneyDetailBlocks/dateAndPriceSection/dateAndPriceSection';
import servicesSection from './JourneyDetailBlocks/servicesSection/servicesSection';
import iconsSection from './JourneyDetailBlocks/iconsSection/iconsSection';
import daysSection from './JourneyDetailBlocks/daysSection/daysSection';
import testimonialSection from './JourneyDetailBlocks/testimonialSection/testimonialSection';
import similarToursSection from './JourneyDetailBlocks/similarToursSection/similarToursSection';
import variantSwitcher from './JourneyDetailBlocks/variantSwitcher/variantSwitcher';
import journeyBooking from './JourneyDetailBlocks/journeyBooking/journeyBooking';
import conditionBlock from '../utils/condition';
import { blockCategories } from './categories';
import teaserFieldSelect from './TeaserBlocks/teaserBlockSelect';
import operationManager from './JourneyDetailBlocks/operationManager/operationManager';
import videosSection from './JourneyDetailBlocks/videosSection/videosSection';
import shipField from './JourneyDetailBlocks/shipField/shipField';

export const grapesJsBlocks = async (
    editor,
    dynamicBlockConfig,
    website,
    menuConfig,
    pagesList,
    data,
    blocksConfig
) => {
    // Basic
    section(editor);
    Heading(editor);
    Text(editor);
    Paragraph(editor);
    linkBlock(editor);
    button(editor);
    iconBlock(editor);
    linkbox(editor);
    Image(editor);
    imageBox(editor);
    gallery(editor);
    list(editor);
    tabs(editor);
    popover(editor);
    swiperSlider(editor);
    addAccordionComponent(editor);
    Video(editor);
    customCodeBlock(editor);
    Embed(editor);
    divider(editor);
    spacer(editor);
    breadcrumbs(editor, pagesList, data);
    mapBlock(editor);

    // Layout
    div(editor);
    layoutColumns(editor);
    dynamicColumns(editor);
    FlexRow(editor);
    Grid(editor);
    Container(editor);

    translationTextBlock(editor);
    LoginModal(editor);

    sioSections({ editor, website });

    // blogsList(editor);
    // offersList(editor);
    // eventsList(editor);

    if (blocksConfig?.showDynamicFields) {
        fieldWrapper(editor, {
            fieldOptions: blocksConfig.fieldOptions,
            defaultField: blocksConfig.defaultField,
            category: blockCategories[blocksConfig?.fieldType],
        });
        wishlistButton(editor, {
            category: blockCategories[blocksConfig?.fieldType],
        });
        daysCount(editor, {
            category: blockCategories[blocksConfig?.fieldType],
        });
        cheapestPrice(editor, {
            category: blockCategories[blocksConfig?.fieldType],
        });
        if (blocksConfig?.fieldType === 'intentBlock') {
            intentBlock(editor);
        }
        if (blocksConfig?.fieldType === 'teaser') {
            journeyDateSelect(editor);
            teaserFieldSelect(editor);
            conditionBlock(editor, {
                category: blockCategories[blocksConfig?.fieldType],
                fieldOptions: blocksConfig.fieldOptions,
                defaultField: blocksConfig.defaultField,
            });
        }
        if (blocksConfig?.fieldType === 'journeyDetail') {
            journeyDetailBreadcrumbs(editor);
            navigationBar(editor);
            gallerySection(editor);
            locationSection(editor);
            dateAndPriceSection(editor);
            servicesSection(editor);
            iconsSection(editor);
            daysSection(editor);
            testimonialSection(editor);
            similarToursSection(editor);
            variantSwitcher(editor);
            journeyBooking(editor);
            operationManager(editor);
            videosSection(editor);
            shipField(editor);
            conditionBlock(editor, {
                category: blockCategories[blocksConfig?.fieldType],
                fieldOptions: blocksConfig.fieldOptions,
                defaultField: blocksConfig.defaultField,
            });
        }
    }

    if (blocksConfig?.showReferenceFields) {
        fieldWrapper(editor, {
            fieldOptions: blocksConfig.fieldOptions,
            defaultField: blocksConfig.defaultField,
            category: blockCategories.page,
        });
        landingPageImage(editor, {
            fieldOptions: blocksConfig.landingPageImageFieldOptions || [],
            defaultProperty:
                blocksConfig.landingPageImageFieldOptions?.[0]?.value || null,
            category: blockCategories.page,
        });
    }
    searchInput(editor);
    LanguageSwitcher(editor);
    menuBlock(editor, menuConfig);
    SearchBar(editor);
    TimeStamp(editor);

    reactComponent(editor);
    ChoiceDisplay(editor);
    ReferenceDisplayComponent(editor);

    if (dynamicBlockConfig?.length > 0) {
        dynamicBlockConfig.forEach((config) => {
            FormEditor(editor, config);
        });
    }

    // editor.BlockManager.getCategories().each((ctg) => {
    //     if (ctg.id !== 'Basic') {
    //         ctg.set('open', false);
    //     }
    // });
};
